import { Component, OnInit } from '@angular/core';
import {TitleHeaderService} from "../title-header/title-header.service";

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {

  constructor(private titleHeaderService: TitleHeaderService) { }

  ngOnInit() {
    this.titleHeaderService.setTitle("Info");
  }

}
